import {Button, useDialog} from 'platform/components';
import {Box, HStack, Text} from 'platform/foundation';

import i18n from '@dms/i18n';

import {FinancingCellRates} from '../types/FinancingCellRates';
import {BulkFinancingRatesDialog} from './BulkFinancingRatesDialog';

interface FinancingMatrixBulkActionsProps {
  selectedCount: number;
  onClear: () => void;
  onApply: (rates: FinancingCellRates) => void;
  onDelete: () => void;
}

export function FinancingMatrixBulkActions(props: FinancingMatrixBulkActionsProps) {
  const [isDialogOpen, openRatesDialog, closeRatesDialog] = useDialog();

  if (props.selectedCount === 0) {
    return null;
  }

  return (
    <>
      <Box paddingVertical={2} data-testid="financing-matrix-bulk-actions">
        <HStack spacing={2} align="center" wrap>
          <Text size="small" color="secondary">
            {i18n.t('page.vehicle.financingAndLeasing.selectedCells', {
              count: props.selectedCount,
            })}
          </Text>
          <Button
            title={i18n.t('general.actions.clear')}
            leftIcon="content/clear"
            variant="secondary"
            size="small"
            onClick={props.onClear}
          />
          <Button
            title={i18n.t('page.vehicle.financingAndLeasing.setRates')}
            leftIcon="image/edit"
            size="small"
            onClick={() => openRatesDialog()}
          />
        </HStack>
      </Box>
      <BulkFinancingRatesDialog
        isOpen={isDialogOpen}
        selectedCount={props.selectedCount}
        onApply={props.onApply}
        onDelete={props.onDelete}
        onClose={closeRatesDialog}
      />
    </>
  );
}
